import { render } from "./TargetSetSection.vue?vue&type=template&id=e9714bca&scoped=true"
import script from "./TargetSetSection.vue?vue&type=script&lang=js"
export * from "./TargetSetSection.vue?vue&type=script&lang=js"

import "./TargetSetSection.vue?vue&type=style&index=0&id=e9714bca&scoped=true&lang=css"

import exportComponent from "../../../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9714bca"]])

export default __exports__